<template>
  <mt-popup v-model="popupVisible" position="center" :closeOnClickModal="false">
    <div class="popbox">
      <span>{{ $t("安全验证") }}</span>
      <p v-if="loading" class="loading-tip">{{ $t("正在加载...") }}</p>
      <div
        v-show="!loading"
        ref="turnstileEl"
        class="turnstile-wrap"
      />
      <div class="footer">
        <button class="btn1" type="button" @click.stop="cancel">
          {{ $t("取消") }}
        </button>
      </div>
    </div>
  </mt-popup>
</template>

<script>
import { httpGetCode } from "@/api/userCenter";
import { TURNSTILE_SITE_KEY } from "@/constants/turnstile";
import {
  whenTurnstileReady,
  renderTurnstile,
  resetTurnstile,
  removeTurnstile,
  getTurnstileLanguage,
} from "@/utils/turnstile";
import { mapState } from "vuex";
import { Toast } from "mint-ui";

const POPUP_ANIM_MS = 200;

export default {
  name: "ImageVerify",
  props: {
    scene: {
      type: String,
      required: true,
    },
    username: {
      type: String,
    },
  },
  data() {
    return {
      popupVisible: false,
      loading: false,
      sending: false,
      token: "",
      widgetId: null,
      initSeq: 0,
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
    turnstileLanguage() {
      return getTurnstileLanguage(this.$i18n && this.$i18n.locale);
    },
  },
  watch: {
    popupVisible(val) {
      if (!val) {
        this.initSeq += 1;
        this.loading = false;
        this.destroyWidget();
      }
    },
  },
  beforeDestroy() {
    this.destroyWidget();
  },
  methods: {
    uname() {
      return (
        this.username ||
        (this.userInfo && (this.userInfo.mobile || this.userInfo.user_email))
      );
    },
    run() {
      if (this.sending) return;
      this.token = "";
      this.popupVisible = true;
      this.loading = true;
      this.$nextTick(() => {
        setTimeout(() => {
          this.initTurnstile();
        }, POPUP_ANIM_MS);
      });
    },
    async initTurnstile() {
      const seq = ++this.initSeq;
      this.destroyWidget();
      try {
        await whenTurnstileReady();
        if (
          seq !== this.initSeq ||
          !this.popupVisible ||
          !this.$refs.turnstileEl
        ) {
          return;
        }
        this.widgetId = renderTurnstile(this.$refs.turnstileEl, {
          sitekey: TURNSTILE_SITE_KEY,
          language: this.turnstileLanguage,
          action: this.scene,
          callback: (token) => {
            this.token = token;
            this.dosend();
          },
          "error-callback": (errorCode) => {
            this.token = "";
            const code = String(errorCode || "");
            console.warn(
              "[Turnstile] error",
              code,
              "on",
              window.location.hostname
            );
            if (code === "110200") {
              Toast(this.$t("当前域名未授权验证"));
            } else {
              Toast(this.$t("验证失败，请重试"));
            }
            resetTurnstile(this.widgetId);
          },
          "expired-callback": () => {
            this.token = "";
            resetTurnstile(this.widgetId);
          },
          "timeout-callback": () => {
            this.token = "";
            Toast(this.$t("验证失败，请重试"));
            resetTurnstile(this.widgetId);
          },
        });
      } catch (err) {
        console.warn("[Turnstile] init failed", err);
        Toast(this.$t("验证失败，请重试"));
        this.popupVisible = false;
      } finally {
        if (seq === this.initSeq) this.loading = false;
      }
    },
    destroyWidget() {
      removeTurnstile(this.widgetId);
      this.widgetId = null;
      if (this.$refs.turnstileEl) {
        this.$refs.turnstileEl.innerHTML = "";
      }
    },
    cancel() {
      this.popupVisible = false;
    },
    dosend() {
      if (!this.token || this.sending) return;
      this.sending = true;
      httpGetCode({
        username: this.uname(),
        scene: this.scene,
        "cf-turnstile-response": this.token,
      })
        .then((res) => {
          this.popupVisible = false;
          Toast((res && res.msg) || this.$t("发送成功"));
          this.$emit("imageCallback");
          this.sending = false;
          this.token = "";
        })
        .catch((res) => {
          this.token = "";
          resetTurnstile(this.widgetId);
          if (String(res) === "20002") {
            Toast(this.$t("验证失败，请重试"));
          } else if (String(res) === "0") {
            this.cancel();
          }
          this.sending = false;
        });
    },
  },
};
</script>

<style scoped>
.popbox {
  width: 90vw;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  background: #fff;
}

.loading-tip {
  margin: 24px 0;
  color: #888;
  font-size: 14px;
}

.turnstile-wrap {
  min-height: 65px;
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.footer {
  display: flex;
  align-items: center;
  width: 100%;
  border-top: 1px solid #c0c0c0;
  margin-top: 8px;
}

.btn1 {
  flex: 1;
  text-align: center;
  padding: 10px 0;
  background-color: transparent;
  border: none;
}
</style>
